import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})


export class ActionsTypeService extends GenericService<any>{
    actionTypesSupplierTaskUrl: string = '/ActionType/SupplierTask';

    constructor(private http: HttpClient) {
        super(http,'/ActionType/', environment.Services.AlphaURLSlot1)
    }
    getActionTypesSupplierTask() {
        return this._http.get(this.rootUrl + this.actionTypesSupplierTaskUrl, this.generateHeaders());
      }

      private generateHeaders() {
        let headersConfig = {
            'Content-Type': 'application/json'
        };

        return {
            headers: new HttpHeaders(headersConfig),
        };
    }
}